import vmClient from 'app/services/vmClient';
import { IEntity, Entity, IEntityType, EntityStringId } from 'app/types/entity';
import { IUserProfile, UserProfile } from 'app/constants/schemas/UserProfile';
import { IWordUsageAnswer, WordUsageAnswer } from 'app/constants/schemas/WordUsageAnswer';
import { DateMarshaller } from 'app/constants/schemas/Date';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface IWordUsageQuestion extends IEntity {
  attributes: {
    id: EntityStringId;
    language: Language;
    question: string;
    createdAt: Date;
  };
  associations: {
    asker: IUserProfile;
    answers: IWordUsageAnswer[];
  };
}

export type WordUsageQuestion = Entity<IWordUsageQuestion>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WordUsageQuestion: IEntityType<IWordUsageQuestion> = vmClient.defineClass({
  typeName: 'Word.UsageQuestion',
  version: 1,
  persisted: true,
  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    question: {
      type: 'string',
      notNull: true,
    },
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
  },
  associations: {
    asker: {
      type: UserProfile,
      notNull: true,
      shared: true,
    },
    answers: {
      type: WordUsageAnswer,
      notNull: true,
      collection: true,
    },
  },
});
